import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  category: [],
  categoryWithMerchant: [],
  merchant: [],
  enableApplyButton: false,
  applyButtonClicked: false,
};
const selectedFilterSlice = createSlice({
  name: "selectedFilterSlice",
  initialState,
  reducers: {
    setFilterCategory(state, action) {
      state.category = action.payload;
    },
    setFilterCategoryWithMerchant(state, action) {
      state.categoryWithMerchant = action.payload;
    },
    setFilterMerchants(state, action) {
      state.merchant = action.payload;
    },
    setEnableApplyButton(state, action) {
      state.enableApplyButton = action.payload;
    },
    setApplyButtonClicked(state, action) {
      state.applyButtonClicked = action.payload;
    },
    resetFilters(state, action) {
      state.category = [];
      state.categoryWithMerchant = [];
      state.merchant = [];
      state.enableApplyButton = false;
      state.applyButtonClicked = false;
    },
  },
});

export const {
  setFilterCategory,
  setFilterCategoryWithMerchant,
  setFilterMerchants,
  setEnableApplyButton,
  setApplyButtonClicked,
  resetFilters,
} = selectedFilterSlice.actions;
export default selectedFilterSlice.reducer;
